// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.select-category-modal__input .sk-input__input-wrapper .sk-input__input {\n  margin-bottom: 0;\n  border-radius: 4px;\n}\n", ""]);
// Exports
module.exports = exports;
